export const ORDER_BY = [
  'companyId',
  'companyName',
  'email',
  'firstName',
  'id',
  'isActive',
  'lastName',
] as const;
